// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-c98af276]{display:flex;flex-direction:column;flex-basis:30%}.switch[data-v-c98af276]{display:flex;margin-top:0}.field[data-v-c98af276]{display:flex;flex-direction:column;margin-bottom:20px}.label[data-v-c98af276]{margin-bottom:10px;color:#000;font-weight:600;line-height:1.21429rem}", ""]);
// Exports
module.exports = exports;
